// extracted by mini-css-extract-plugin
module.exports = {"plate":"ManagerCall_plate__EWHvQ","tabList":"ManagerCall_tabList__5bz2Z","title":"ManagerCall_title__slerC"};